import React from 'react';
import { getProductIcons, getProductColor } from '../../utils';
import styles from './dpsProductGroupHeader.module.scss';

function DpsProductGroupHeader(props) {
    const { category } = props;
    return (
        <span
            style={{
                backgroundColor: getProductColor(category),
            }}
            className={styles['dps-product-group-header']}
        >
            <span>{getProductIcons(category, 19.5)}</span>
            <span className={styles['dpsproduct-group-category']}>
                {category}
            </span>
        </span>
    );
}

export default DpsProductGroupHeader;
